import React, { Component } from 'react';
import { Row, Col, Grid, Button } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import ReactDataGrid from 'react-data-grid'
import { Data } from 'react-data-grid-addons';
import _ from 'lodash';
import moment from 'moment';

const styles = {
  table: {
    display: 'flex',
    flexDirection: 'row',
    width: '625px',
    alignItems: 'center',
  },
}

class PoListModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: [],
    };
  }

  componentDidMount() {
    this.setState({
      rows: this.props.poLines,
    })
  }

  render() {
    const getRows = () => {
      return Data.Selectors.getRows(this.state);
    }

    const getSize = () => {
      return getRows().length;
    }

    const rowGetter = rowIdx => {
      var rows = getRows();
      return rows[rowIdx];
    }
    const columns = [
      {
        key: 'ponum',
        name: <Translate value="po_no" />,
        resizable: true,
        width: 100,
      },
      {
        key: 'po_qty',
        name: <Translate value="qty" />,
        width: 60,
        resizable: true,
      },
      {
        key: 'unitprices',
        name: <Translate value="unit_dollarsign" />,
        resizable: true,
        width: 60,
      },
      {
        key: 'vendor_name',
        name: <Translate value="vendor" />,
        resizable: true,
        width: 120,
      },
      {
        key: 'order_date',
        name: <Translate value="ordered" />,
        resizable: true,
        width: 95,
        formatter: ({ value }) => {
          return <div>
            {value ? moment(value).format('MM-DD-YYYY') : ''}
          </div>
        }
      },
      {
        key: 'eta_date',
        name: <Translate value="eda_date" />,
        width: 95,
        resizable: true,
        formatter: ({ value }) => {
          return <div>
            {value ? moment(value).format('MM-DD-YYYY') : ''}
          </div>
        }
      },
      {
        key: 'creator',
        name: <Translate value="creator" />,
        width: 95,
        resizable: true,
      },
    ];
    return (
      <div id='productInvPOTbale' style={styles.table}>
        <ReactDataGrid
          rowKey="id"
          rowHeight={25}
          columns={columns}
          minHeight={300}
          rowGetter={rowGetter}
          rowsCount={getSize()}
        />
      </div>
    )
  }
}

export default PoListModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Products/components/PoListModal.jsx